import React from "react";
import { Leaf, ShieldCheck, Globe, Activity } from "lucide-react";
import { Separator } from "@/components/ui/separator";
const trustBadges = [{
  id: 1,
  title: "Not-for-profit",
  description: "Community-driven and mission-focused.",
  icon: Leaf
}, {
  id: 2,
  title: "Safe & Secure",
  description: "Highest standards for child safety.",
  icon: ShieldCheck
}, {
  id: 3,
  title: "Inclusive Learning",
  description: "Accessible education for everyone.",
  icon: Globe
}, {
  id: 4,
  title: "Future-Focused",
  description: "Practical skills for the digital age.",
  icon: Activity
}];
export default function TheFutureReadyDifference() {
  return <section data-section-id="223310" id="the-future-ready-difference" className="relative bg-background text-foreground w-full">
      <Separator className="absolute top-0 w-full bg-border/30" />
      
      <div className="container mx-auto px-4 py-8 md:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          {trustBadges.map((badge, i) => {
          const Icon = badge.icon;
          return <div key={badge.id} data-index={i} className="flex flex-col items-center text-center space-y-3 group">
                <div className="text-chart-2 transition-transform duration-500 group-hover:scale-110">
                  <Icon className="size-10" strokeWidth={1.5} />
                </div>
                <div className="space-y-1">
                  <h3 className="text-sm font-bold font-default text-foreground tracking-tight">
                    {badge.title}
                  </h3>
                  <p className="text-xs font-default text-muted-foreground max-w-[200px] mx-auto">
                    {badge.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>

      <Separator className="absolute bottom-0 w-full bg-border/30" />
    </section>;
}